<template>
  <a-table :pagination='pagination' :loading='listLoading' bordered rowKey='id' :columns='columns'  class="tableFixBox" :data-source='list' :scroll="{ x: 'max-content'}" @change="changePage">
      <template #action="{record}">
          <a-button type="link"  v-if="record.file_key" @click='downloadForm(record.file_key)'>下载</a-button>
          <span class="s_c999" v-else>无</span>
      </template>
  </a-table>
</template>
<script>
import { adminExport } from '@/api/antiFleeing';
import {marketingExport} from "@/api/qrcodeActivitys";
import { onMounted, reactive, toRefs } from 'vue';
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import config from '@/config'
const columns = [
 {
   title: "导出时间",
   dataIndex: "create_time",
   key: "create_time",
 },
  {
   title: "生成进度",
   dataIndex: "status_text",
   key: "status_text",
 },
 {
   title: "有效期剩余",
   dataIndex: "last_day",
   key: "last_day",
 },
  {
   title: "数据类型",
   dataIndex: "type_text",
   key: "type_text",
 },
  {
   title: "操作",
   dataIndex: "action",
    slots: { customRender: "action" }
 },
]
export default {
 name:'warehousTable',
 props:{
    searchType:{
      type:Number||String,
      default:3
    },
    exportType:{
       type:Number,
       default:1 //1智能防窜 2智能营销 
    }
 },
 setup(props,{emit}){
     const state = reactive({
        listLoading:false,
        list:[],
         pagination:{ 
              total:0,
              current:1,
              pageSize:5,
              defaultPageSize:5,
              showSizeChanger:true,
              pageSizeOptions:['5', '8', '10', '12'], 
              showQuickJumper:true, 
              showTotal:(total)=> `共 ${total} 条`,
         },
         search:{
           page:1,
           limit:5
         },
     })
     const downloadForm = (url) =>{
       var http = '';
       if(props.exportType == 1){
         http =  config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='
       }else{
         http = config.smartUrl[process.env.VUE_APP_type]+'download/asyncFile?key='
       }
       window.open(http+url)
     }
     const methods = {
       async init(){
          state.listLoading = true;
          state.list = []
           let res;
          if(props.exportType == 1){
               res = await adminExport({...state.search,type:props.searchType}).then(res=>res.data);
          }else {
               res = await marketingExport({...state.search,type:props.searchType}).then(res=>res.data);
          }
         
          state.listLoading = false;
          if(iscode(res)){
              state.list = res.data || [];
              state.pagination.total = res.meta.total || 0;
              state.pagination.current = res.meta.current_page || 1;
              state.search.page = res.meta.current_page || 1;
          }else{
            message.error(res.msg)
          }
        },
        changePage(e){
              state.pagination.pageSize = e.pageSize;
              state.pagination.current = e.current;
              state.search.page = e.current;
              state.search.limit = e.pageSize;
               methods.init()
        },
     }

     onMounted(()=>{
       const hide = message.loading('正在加载中...', 0);
       methods.init()
       setTimeout(hide);
     })
     return {
         columns,
         ...toRefs(state),
         ...methods,
         downloadForm
     }
 }
}
</script>